var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.59,21.25c-.05-.16-.4-.4-1-.72l-.73-.41L23,19.64l-.74-.42L21.89,19a3.5,3.5,0,0,0-.49-.29.76.76,0,0,0-.39-.1,1.08,1.08,0,0,0-.67.39,6.34,6.34,0,0,0-.75.8,9.9,9.9,0,0,1-.73.85,1,1,0,0,1-.62.39,1.18,1.18,0,0,1-.31-.08l-.28-.11a2,2,0,0,1-.32-.18l-.26-.17a13.88,13.88,0,0,1-3.22-2.37,14.21,14.21,0,0,1-2.38-3.22l-.15-.26a2.59,2.59,0,0,1-.2-.33c0-.09-.08-.19-.11-.28a.81.81,0,0,1-.06-.31,1,1,0,0,1,.38-.62,9.07,9.07,0,0,1,.81-.72,6.34,6.34,0,0,0,.8-.75,1.13,1.13,0,0,0,.39-.68.76.76,0,0,0-.1-.39,2.36,2.36,0,0,0-.29-.48l-.23-.34L12.28,9c-.14-.25-.24-.49-.4-.81s-.31-.56-.41-.73c-.32-.65-.57-1-.73-1a.71.71,0,0,0-.29,0,4.82,4.82,0,0,0-1,.14,5,5,0,0,0-.93.29A3.6,3.6,0,0,0,7.08,8.47,5.25,5.25,0,0,0,6.4,11a4.31,4.31,0,0,0,0,.71,4.38,4.38,0,0,0,.17.8c.08.29.15.5.2.65s.14.39.28.75.22.59.24.67A12.41,12.41,0,0,0,8.47,17a20.75,20.75,0,0,0,2.93,3.61A20.75,20.75,0,0,0,15,23.55a13.06,13.06,0,0,0,2.42,1.14l.67.24.75.28.65.19a5.29,5.29,0,0,0,.81.17,4.17,4.17,0,0,0,.71.05,5.22,5.22,0,0,0,2.53-.69,3.66,3.66,0,0,0,1.66-1.45,6.41,6.41,0,0,0,.3-.94,5.55,5.55,0,0,0,.08-1A.71.71,0,0,0,25.59,21.25Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.85,
    y: 6.38,
    width: 2.77,
    height: 1.72
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.03,
    y: 6.38,
    width: 5.89,
    height: 1.72
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.85,
    y: 10.03,
    width: 2.77,
    height: 1.72
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.03,
    y: 10.03,
    width: 5.89,
    height: 1.72
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.85,
    y: 13.66,
    width: 2.77,
    height: 1.72
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.03,
    y: 13.66,
    width: 5.89,
    height: 1.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarDevices);
export default __webpack_public_path__ + "static/media/toolbar-devices.cceec339.svg";
export { ForwardRef as ReactComponent };